var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-3 -7.5)"},[React.createElement("path",{"d":"M4.5,18h27","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M4.5,9h27","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M4.5,27h27","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":2})]));
}

Menu.defaultProps = {"width":"30","height":"21","viewBox":"0 0 30 21"};

module.exports = Menu;

Menu.default = Menu;
